import { render, staticRenderFns } from "./TestSchedule.vue?vue&type=template&id=4f4bd7d1&"
import script from "./TestSchedule.vue?vue&type=script&lang=js&"
export * from "./TestSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports